<template>
  <div class="content-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.content-container {
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
</style>
